var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('side-nav',{staticClass:"white-skin",attrs:{"open":_vm.toggle}}),_c('div',{staticClass:"flexible-content"},[_c('navbar',{attrs:{"page":_vm.activePage}}),_c('div',{staticClass:"mainContent"},[_c('router-view')],1),_c('div',{staticClass:"white-skin"},[_c('copyrights')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }